import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

export const MATERIAL_CORE = [
  MatCardModule,
  MatTooltipModule,
  MatButtonModule,
  MatIconModule,
  MatChipsModule,
  MatDividerModule,
  MatDialogModule,
] as const;
